import { render, staticRenderFns } from "./MercadoPagoInstallments.vue?vue&type=template&id=4d9f5514"
import script from "./MercadoPagoInstallments.vue?vue&type=script&lang=js"
export * from "./MercadoPagoInstallments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports